module.exports = __webpack_public_path__ + "img/05.95d7e668.png";